import { DropdownWithSearch } from "InnoUI/innoinput";
import { intervalCycle } from "utils/optionData/utils";

const WeekDaysDropdown = ({
  onChange = () => {},
  defaultValue = 0, // Set default value to 0
  disabled = true,
  name,
  disabledDropdown,
}) => {
  const projectOptions = intervalCycle.map((data) => ({
    id: data.id,
    label: data.label,
  }));

  const handleDropdownChange = (value) => {
    const selectedOption = projectOptions.find((option) => option.id === value);
    const selectedLabel = selectedOption ? selectedOption.label : "";
    onChange(name, selectedLabel); // Send name and selected value (ID)
  };

  return (
    <DropdownWithSearch
      defaultValue={defaultValue} // Ensure defaultValue is passed
      options={projectOptions}
      onChange={handleDropdownChange}
      borderColor="#ED850C"
      disabled={disabled}
      width="130px"
      disabledDropdown={disabledDropdown}
    />
  );
};

export default WeekDaysDropdown;
